import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"max-width":"900"},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c(VCard,[_c(VCardTitle,{staticClass:"headline grey lighten-2 mb-5",attrs:{"primary-title":""}},[_vm._t("heading"),_c(VSpacer),_c(VBtn,{attrs:{"icon":""}},[_c(VIcon,{on:{"click":function($event){_vm.showDialog = false}}},[_vm._v("mdi-close")])],1)],2),_c(VCardText,[_vm._t("body")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }